module.exports = __webpack_public_path__ + "images/job/detail/detail_icon02-12a73336f98ca3d4ca82bf69aaebce02.png";